import * as React from 'react'
import {
  Button,
  type ButtonProps,
} from '~/components/ui/inputs/button/Button.tsx'
import { cn } from '~/utils/misc.tsx'
import { useSpinDelay } from 'spin-delay'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../tooltip.tsx'
import { Icon } from '../../icons/icon.tsx'

export const StatusButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    status: 'pending' | 'success' | 'error' | 'idle'
    message?: string | null
    spinDelay?: Parameters<typeof useSpinDelay>[1]
  }
>(({ message, status, className, children, spinDelay, ...props }, ref) => {
  const delayedPending = useSpinDelay(status === 'pending', {
    delay: 400,
    minDuration: 300,
    ...spinDelay,
  })
  const companion = {
    pending: delayedPending ? (
      <div className="inline-flex h-6 w-6 items-center justify-center">
        <Icon name="update" className="animate-spin" />
      </div>
    ) : null,
    success: null,
    //   <div className="inline-flex h-6 w-6 items-center justify-center">
    //     <Icon name="check" />
    //   </div>
    error: null,
    //   <div className="inline-flex h-6 w-6 items-center justify-center rounded-full ">
    //     {/* <Icon name="cross-1"  /> */}
    //   </div>
    idle: null,
  }[status]

  return (
    <Button
      ref={ref}
      className={cn('flex justify-center gap-4 font-bold', className)}
      {...props}
    >
      {children}
      {message ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>{companion}</TooltipTrigger>
            <TooltipContent>{message}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        companion
      )}
    </Button>
  )
})
StatusButton.displayName = 'Button'
